import { createElement, Fragment, isValidElement } from 'react';
/**
 * 处理 React.ReactNode 为合法 JSX.Element
 */
export function safeElement(node) {
    return isValidElement(node) ? node : createElement(Fragment, null, node);
}
